import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Subfee.List.IRequest;
type Response = Api.Core.Subfee.List.IResponse;
type Headers = Api.Core.Subfee.List.IHeaders;
const url = '/api/ProductManagement/Subfee';
export default async function subfeeListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
